export function mapErrorCodeToMessage(code?: string, fallback?: string): string | undefined {
  if (!code) return fallback;
  const dictionary: Record<string, string> = {
    'VALIDATION.REQUIRED': 'Заполните обязательные поля.',
    'VALIDATION.FK': 'Ссылка на несуществующую запись. Проверьте связанные данные.',
    'CONFLICT.UNIQUE': 'Такие данные уже существуют. Измените значение.',
    'SERVER.ERROR': 'Произошла ошибка на сервере. Попробуйте позже.',
    'API.ERROR': 'Операция не выполнена. Проверьте данные и повторите попытку.',
  };
  return dictionary[code] || fallback;
}



